/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Table,
  Typography,
  message,
  Select,
  Radio,
  Popconfirm,
} from "antd";
import { Card, Col, Divider, Flex, Row, Space } from "antd";
import OptionService from "../../../service/ERP/Options.service";
import PurchaseOrderService from "../../../service/ERP/PurchaseOrder.service";
import {
  SaveFilled,
  SearchOutlined,
  QuestionCircleOutlined,
  PlusOutlined,
  EditOutlined,
} from "@ant-design/icons";
import ModalSupplier from "../../../components/modal/ERP/supplier/ModalSupplier";
import {
  purchaseorderForm,
  columnsParametersEditable,
  componentsEditable,
} from "./model";
// import { ModalMaterial } from "../../../components/modal/ERP/modal-material";
import ModalBuyMaterial from "../../../components/modal/ERP/buymaterial/ModalBuyMaterial";
import ModalSelectLot from "../../../components/modal/ERP/buymaterial/ModalSelectLot";
import dayjs from "dayjs";
import { delay, formatMoney } from "../../../utils/util";
import { ButtonBack } from "../../../components/button";
import { useLocation, useNavigate } from "react-router-dom";
import { RiDeleteBin5Line } from "react-icons/ri";
import { LuPackageSearch } from "react-icons/lu";
import { CloseCircleFilledIcon } from "../../../components/icon";

const opservice = OptionService();
const poservice = PurchaseOrderService();
const gotoFrom = "/ERP/purchase-order";
const dateFormat = "DD/MM/YYYY";
function PurchaseOrderManage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { config } = location.state || { config: null };
  const [form] = Form.useForm();
  /** Modal handle */
  const [openSupplier, setOpenSupplier] = useState(false);
  const [openProduct, setOpenProduct] = useState(false);
  /** เลือก MOQ ผ่าน modal */
  const [openLot, setOpenLot] = useState(false);
  const [lotRecord, setLotRecord] = useState(null);
  /** PurchaseOrder state */
  const [poCode, setPoCode] = useState(null);
  /** เลขรันอัตโนมัติที่ระบบออกให้ ใช้เทียบว่าผู้ใช้แก้รหัสเองหรือไม่ */
  const [autoPoCode, setAutoPoCode] = useState(null);
  /** null = ยังไม่ได้ตรวจ, true = ซ้ำ, false = ใช้ได้ */
  const [poCodeDup, setPoCodeDup] = useState(null);
  const poCodeCheckRef = useRef(null);
  /** Detail Data State */
  const [listDetail, setListDetail] = useState([]);
  const [formDetail, setFormDetail] = useState(purchaseorderForm);

  /* ---------- ค่าบริการเพิ่ม ----------
     listService = รายการในใบนี้ , serviceOption = ทะเบียนรหัส/ชื่อค่าบริการ
     ทะเบียนใช้เฉพาะหน้านี้ เพิ่มได้จากปุ่ม + ไม่มีหน้าจัดการแยก */
  const [listService, setListService] = useState([]);
  const [serviceOption, setServiceOption] = useState([]);
  const [openServiceMaster, setOpenServiceMaster] = useState(false);
  /* ฟอร์มในหน้าจัดการรหัสค่าบริการ — editing = รหัสเดิมตอนกดแก้ไข */
  const [newService, setNewService] = useState({ code: "", name: "" });
  const [editingService, setEditingService] = useState(null);
  const [unitOption, setUnitOption] = useState([]);
  const cardStyle = {
    backgroundColor: "#f0f0f0",
    height: "calc(100% - (25.4px + 1rem))",
  };

  useEffect(() => {
    const initial = async () => {
      if (config?.action !== "create") {
        const res = await poservice
          .get(config?.code)
          .catch((error) => message.error("get PurchaseOrder data fail."));
        // console.log(res.data)
        const { header, detail, services } = res.data;
        const { pocode, podate } = header;

        setFormDetail(header);
        setListDetail(detail);
        setListService(
          (services || []).map((v, i) => ({ ...v, seq: v.seq || i + 1 }))
        );
        setPoCode(pocode);
        form.setFieldsValue({
          ...header,
          podate: dayjs(podate),
          deldate: dayjs(header.deldate),
        });

        // setTimeout( () => {  handleCalculatePrice(head?.valid_price_until, head?.dated_price_until) }, 200);
        // handleChoosedSupplier(head);
      } else {
        const { data: code } = (
          await poservice.code().catch((e) => {
            message.error("get PurchaseOrder code fail.");
          })
        ).data;
        setPoCode(code);
        setAutoPoCode(code);

        form.setFieldValue("payment", "เงินสด");
        const ininteial_value = {
          ...formDetail,
          pocode: code,
          podate: dayjs(new Date()),
          deldate: dayjs(new Date()),
          doc_status: "ยังไม่ได้รับของ",
        };

        setFormDetail(ininteial_value);
        form.setFieldsValue(ininteial_value);
        form.setFieldValue("vat", "7");
      }
      const [unitOprionRes] = await Promise.all([
        opservice.optionsUnit({ p: "unit-option" }),
      ]);
      // console.log(unitOprionRes.data.data)
      setUnitOption(unitOprionRes.data.data);

      loadServiceOption();
    };

    initial();
    return () => {};
  }, []);

  useEffect(() => {
    if (listDetail) handleSummaryPrice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listDetail, listService]);

  /* ตรวจรหัสใบสั่งซื้อซ้ำแบบหน่วงเวลา กันยิง API ทุกตัวอักษร
     ถ้าเป็นเลขรันอัตโนมัติที่ระบบออกให้ ไม่ต้องตรวจ */
  const handlePoCodeChange = (value) => {
    const code = (value || "").trim();
    setPoCode(code);
    setPoCodeDup(null);

    if (poCodeCheckRef.current) clearTimeout(poCodeCheckRef.current);
    if (!code || code === autoPoCode) return;

    poCodeCheckRef.current = setTimeout(() => {
      poservice
        .checkCode(code)
        .then((res) => setPoCodeDup(!!res.data?.exists))
        .catch(() => setPoCodeDup(null));
    }, 400);
  };

  useEffect(() => {
    return () => {
      if (poCodeCheckRef.current) clearTimeout(poCodeCheckRef.current);
    };
  }, []);

  /* คำนวณยอดท้ายบิล
     total_price      = ยอดรวมหลังหักส่วนลดรายบรรทัด
     total_discount   = ส่วนลดรวมท้ายบิล (ตัวเลขที่เก็บจริง)
     discount_percent = % ที่ใช้คำนวณ total_discount เก็บไว้อ้างอิงเท่านั้น */
  /* ---------- ค่าบริการเพิ่ม ---------- */
  const loadServiceOption = () => {
    poservice
      .serviceList()
      .then((res) => setServiceOption(res.data?.data || []))
      .catch(() => {});
  };

  const serviceTotal = listService.reduce(
    (a, v) => a + Number(v?.amount || 0),
    0
  );

  const handleAddServiceRow = () => {
    setListService((prev) => [
      ...prev,
      { seq: prev.length + 1, service_code: null, service_name: null, amount: 0, remark: null },
    ]);
  };

  const handleServiceChange = (seq, patch) => {
    setListService((prev) =>
      prev.map((v) => (v.seq === seq ? { ...v, ...patch } : v))
    );
  };

  const handleServiceDelete = (seq) => {
    setListService((prev) =>
      prev.filter((v) => v.seq !== seq).map((v, i) => ({ ...v, seq: i + 1 }))
    );
  };

  /* เลือกค่าบริการจากทะเบียน → เติมชื่อให้อัตโนมัติ */
  const handleServicePick = (seq, code) => {
    const found = serviceOption.find((o) => o.code === code);
    handleServiceChange(seq, {
      service_code: code || null,
      service_name: found?.name || null,
    });
  };

  /* หน้าจัดการรหัสค่าบริการ — เพิ่ม / แก้ไข / ลบ (ลบได้ถ้ายังไม่ถูกใช้) */
  const handleSaveServiceMaster = () => {
    const code = (newService.code || "").trim();
    const name = (newService.name || "").trim();
    if (!code || !name) {
      message.error("กรุณากรอกรหัสและชื่อค่าบริการ");
      return;
    }

    const req = editingService
      ? poservice.serviceUpdate(editingService, name, code)
      : poservice.serviceAdd(code, name);

    req
      .then((res) => {
        message.success(res.data?.message || "บันทึกเรียบร้อย");
        setNewService({ code: "", name: "" });
        setEditingService(null);
        loadServiceOption();
        /* รหัสถูกแก้ → อัปเดตชื่อที่แสดงในรายการของใบนี้ด้วย */
        setListService((prev) =>
          prev.map((v) =>
            v.service_code === editingService
              ? { ...v, service_code: code, service_name: name }
              : v
          )
        );
      })
      .catch((err) =>
        message.error(err?.response?.data?.message || "บันทึกไม่สำเร็จ")
      );
  };

  const handleEditServiceMaster = (rec) => {
    setEditingService(rec.code);
    setNewService({ code: rec.code, name: rec.name });
  };

  const handleDeleteServiceMaster = (rec) => {
    poservice
      .serviceDelete(rec.code)
      .then((res) => {
        message.success(res.data?.message || "ลบเรียบร้อย");
        if (editingService === rec.code) {
          setEditingService(null);
          setNewService({ code: "", name: "" });
        }
        loadServiceOption();
      })
      .catch((err) =>
        message.error(err?.response?.data?.message || "ลบไม่สำเร็จ")
      );
  };

  const closeServiceMaster = () => {
    setOpenServiceMaster(false);
    setEditingService(null);
    setNewService({ code: "", name: "" });
  };

  const handleSummaryPrice = (override = {}) => {
    const newData = [...listDetail];

    /* ยอดรวม = ราคาสินค้าหลังหักส่วนลดรายบรรทัด + ค่าบริการเพิ่ม
       (ค่าบริการถูกคิด Vat ด้วยเหมือนรายการสินค้า) */
    const total_price =
      newData.reduce(
        (a, v) =>
          (a +=
            Number(v.qty || 0) * Number(v?.price || 0) -
            Number(v?.discount || 0)),
        0
      ) + listService.reduce((a, v) => a + Number(v?.amount || 0), 0);

    const vat = Number(form.getFieldValue("vat") || 0);

    const hasPct = (v) => v !== undefined && v !== null && v !== "";

    let percent = hasPct(override.discount_percent)
      ? override.discount_percent
      : override.discount_percent === null || override.discount_percent === ""
      ? null
      : form.getFieldValue("discount_percent");

    let total_discount;

    if (override.total_discount !== undefined) {
      /* กรอกตัวเลขเอง → ล้าง % ทิ้ง ไม่งั้นรอบหน้าจะถูก % เขียนทับ */
      total_discount = Number(override.total_discount || 0);
      percent = null;
      form.setFieldValue("discount_percent", null);
    } else if (hasPct(percent)) {
      /* มี % อยู่ → % เป็นตัวคุม ยอดรวมเปลี่ยนก็คำนวณส่วนลดใหม่ */
      total_discount =
        Math.round(total_price * (Number(percent) / 100) * 100) / 100;
      form.setFieldValue("total_discount", total_discount);
    } else {
      total_discount = Number(form.getFieldValue("total_discount") || 0);
    }

    // ส่วนลดรวมต้องไม่เกินยอดรวม
    if (total_discount > total_price) {
      total_discount = total_price;
      form.setFieldValue("total_discount", total_discount);
    }

    const after_discount = total_price - total_discount;
    const grand_total_price = after_discount + (after_discount * vat) / 100;

    setFormDetail((state) => ({
      ...state,
      total_price,
      total_discount,
      discount_percent: hasPct(percent) ? percent : null,
      vat,
      grand_total_price,
    }));
  };

  const handleCalculatePrice = (day, date) => {
    const newDateAfterAdding = dayjs(date || new Date()).add(
      Number(day),
      "day"
    );
    const nDateFormet = newDateAfterAdding.format("YYYY-MM-DD");

    setFormDetail((state) => ({ ...state, dated_price_until: nDateFormet }));
    form.setFieldValue("dated_price_until", nDateFormet);
  };

  const handleQuotDate = (e) => {
    const { valid_price_until } = form.getFieldsValue();
    if (!!valid_price_until && !!e) {
      handleCalculatePrice(valid_price_until || 0, e || new Date());
    }
  };

  /** Function modal handle */
  const handleChoosedSupplier = (val) => {
    // console.log(val)
    const fvalue = form.getFieldsValue();
    const addr = [
      !!val?.idno ? `${val.idno} ` : "",
      !!val?.road ? `${val?.road} ` : "",
      !!val?.subdistrict ? `${val.subdistrict} ` : "",
      !!val?.district ? `${val.district} ` : "",
      !!val?.province ? `${val.province} ` : "",
      !!val?.zipcode ? `${val.zipcode} ` : "",
      !!val?.country ? `(${val.country})` : "",
    ];
    const supplier = {
      ...val,
      address: addr.join(""),
      contact: val.contact,
      tel: val?.tel?.replace(/[^(0-9, \-, \s, \\,)]/g, "")?.trim(),
    };

    /* ดึงเงื่อนไขการชำระเงินของผู้ขายมาใช้เป็นค่าตั้งต้น
       ถ้าผู้ขายยังไม่ได้ตั้งไว้ ให้คงค่าที่กรอกอยู่เดิม */
    const payment = val?.payment || fvalue?.payment || formDetail?.payment;

    setFormDetail((state) => ({ ...state, ...supplier, payment }));
    form.setFieldsValue({ ...fvalue, ...supplier, payment });
  };

  const handleItemsChoosed = (value) => {
    /* รายการที่รับของไปแล้วต้องคงอยู่เสมอ แม้ผู้ใช้จะติ๊กออกในหน้าต่างเลือกสินค้า
       และใช้ข้อมูลเดิม (จำนวน/ราคา) ไม่ให้ถูกค่าจากหน้าต่างเลือกทับ */
    const received = listDetail.filter((r) => Number(r?.recamount || 0) > 0);
    const keepCodes = new Set(received.map((r) => r.stcode));
    const merged = [
      ...received,
      ...(value || []).filter((r) => !keepCodes.has(r?.stcode)),
    ];
    setListDetail(merged);
    handleSummaryPrice();
  };

  const handleConfirm = () => {
    form
      .validateFields()
      .then((v) => {
        if (listDetail.length < 1) throw new Error("กรุณาเพิ่ม รายการขาย");

        const invalidQty = listDetail.find(
          (item) =>
            item?.purchase_type !== "LOT" &&
            item?.min_qty &&
            Number(item.qty || 0) < Number(item.min_qty)
        );
        if (invalidQty) {
          throw new Error(
            `สินค้า ${invalidQty.stname || invalidQty.stcode} ต้องสั่งซื้อขั้นต่ำ ${invalidQty.min_qty} หน่วย`
          );
        }

        const invalidLot = listDetail.find((item) => {
          if (item?.purchase_type !== "LOT") return false;
          const size = Number(item.lot_size || 0);
          if (!size) return true;
          const qty = Number(item.qty || 0);
          return qty <= 0 || qty % size !== 0;
        });
        if (invalidLot) {
          throw new Error(
            `สินค้า ${invalidLot.stname || invalidLot.stcode} กรุณาเลือก MOQ และระบุจำนวนให้เป็นจำนวนเท่าของขนาด MOQ`
          );
        }

        /* ตอนสร้างใหม่ : รหัสห้ามว่างและห้ามซ้ำ */
        if (config?.action === "create") {
          const code = (form.getFieldValue("pocode") || "").trim();
          if (!code) throw new Error("กรุณาระบุรหัสใบสั่งซื้อ");
          if (poCodeDup) {
            throw new Error(`รหัสใบสั่งซื้อ ${code} ถูกใช้ไปแล้ว กรุณาเปลี่ยนรหัสใหม่`);
          }
        }

        const header = {
          ...formDetail,
          pocode:
            config?.action === "create"
              ? (form.getFieldValue("pocode") || "").trim()
              : formDetail.pocode,
          podate: dayjs(form.getFieldValue("podate")).format("YYYY-MM-DD"),
          deldate: dayjs(form.getFieldValue("deldate")).format("YYYY-MM-DD"),
          payment: form.getFieldValue("payment"),
          poqua: form.getFieldValue("poqua"),
          remark: form.getFieldValue("remark"),
          vat: form.getFieldValue("vat"),
          ship_to: form.getFieldValue("ship_to") ?? null,
          total_discount: Number(form.getFieldValue("total_discount") || 0),
          discount_percent:
            form.getFieldValue("discount_percent") === "" ||
            form.getFieldValue("discount_percent") === undefined
              ? null
              : form.getFieldValue("discount_percent"),
        };
        const detail = listDetail;
        const services = listService.filter(
          (v) => v?.service_code || v?.service_name || Number(v?.amount || 0) > 0
        );

        const parm = { header, detail, services };
        // console.log(parm)
        const actions =
          config?.action !== "create" ? poservice.update : poservice.create;
        actions(parm)
          .then((r) => {
            handleClose().then((r) => {
              message.success("Request PurchaseOrder success.");
            });
          })
          .catch((err) => {
            /* แสดงข้อความจริงจากเซิร์ฟเวอร์ เช่น รหัสใบสั่งซื้อซ้ำ */
            const msg = err?.response?.data?.message;
            /* ทำเครื่องหมายเลขซ้ำเฉพาะ error เรื่องเลขที่ใบซ้ำ ไม่ใช่ทุก error */
            if (msg && /ซ้ำ|duplicate/i.test(msg)) setPoCodeDup(true);
            message.error(msg || "Request PurchaseOrder fail.");
            console.warn(err);
          });
      })
      .catch((err) => {
        if (err?.errorFields) {
          Modal.error({
            title: "ข้อมูลยังไม่ครบถ้วน",
            content: "กรุณากรอกข้อมูลให้ครบ",
          });
        } else {
          Modal.error({
            title: "ข้อมูลยังไม่ถูกต้อง",
            content: err?.message || "กรุณาตรวจสอบข้อมูลอีกครั้ง",
          });
        }
      });
  };

  const handleCancel = () => {
    poservice
      .deleted(config?.code)
      .then((_) => {
        handleClose().then((r) => {
          message.success("ยกเลิกใบสั่งซื้อเรียบร้อย.");
        });
      })
      .catch((err) => {
        console.warn(err);
        const {
          data: { message: mes },
        } = err.response;
        message.error(mes || "error request");
      });
  };

  const handleClose = async () => {
    navigate(gotoFrom, { replace: true });
    await delay(300);
    // console.clear();
  };

  const handleDelete = (code) => {
    const itemDetail = [...listDetail];
    const newData = itemDetail.filter((item) => item?.stcode !== code);
    setListDetail([...newData]);
  };

  const handleSave = (row) => {
    const newData = (r) => {
      const newData = [...listDetail];

      const ind = newData.findIndex((item) => row.stcode === item?.stcode);
      // กันกรณีหาแถวไม่เจอ — splice(-1,...) จะไปทับแถวสุดท้าย
      if (ind < 0) return newData;
      const item = newData[ind];

      let patch = { ...row };

      if (row.key === "lot_size" && item?.purchase_type === "LOT") {
        const lot = (item?.lots || []).find(
          (l) => Number(l.lot_size) === Number(row.lot_size)
        );
        if (lot) {
          const size = Number(lot.lot_size) || 0;
          patch = {
            ...patch,
            lot_size: lot.lot_size,
            qty: size,
            price: size ? Number(lot.lot_price) / size : 0,
          };
        }
      }

      newData.splice(ind, 1, {
        ...item,
        ...patch,
      });
      return newData;
    };
    setListDetail([...newData()]);
  };

  /* เปิด modal เลือก MOQ */
  const handleModalSelectLot = (e, record) => {
    setLotRecord(record);
    setOpenLot(true);
  };

  /* เลือก MOQ แล้ว → ส่งเข้า handleSave ให้ logic เดิมตั้งจำนวน/ราคาต่อหน่วยให้ */
  const handleConfirmLot = (lot) => {
    handleSave({
      stcode: lotRecord?.stcode,
      lot_size: lot?.lot_size,
      key: "lot_size",
    });
  };

  /* แก้ไขใบสั่งซื้อได้ทั้งตอนยังไม่รับของ และตอนรับของยังไม่ครบ
     — ตอนรับไม่ครบ แก้/ลบได้เฉพาะรายการที่ยังไม่ได้รับเลย (recamount = 0)
       รายการที่รับไปแล้วบางส่วนหรือครบแล้ว ล็อกไว้ และเปลี่ยนผู้ขายไม่ได้ */
  const PO_EDITABLE_STATUS = ["ยังไม่ได้รับของ", "ยังรับของไม่ครบ"];
  const canEditPo = PO_EDITABLE_STATUS.includes(formDetail.doc_status);
  const isPartialReceived = formDetail.doc_status === "ยังรับของไม่ครบ";
  const isRowReceived = (record) => Number(record?.recamount || 0) > 0;

  const handleAction = (record) => {
    const itemDetail = [...listDetail];
    return itemDetail.length >= 1 ? (
      <Button
        className="bt-icon"
        size="small"
        danger
        icon={
          <RiDeleteBin5Line style={{ fontSize: "1rem", marginTop: "3px" }} />
        }
        onClick={() => handleDelete(record?.stcode)}
        disabled={!record?.stcode || isRowReceived(record) || !canEditPo}
        title={isRowReceived(record) ? "รับของรายการนี้ไปแล้ว ลบไม่ได้" : undefined}
      />
    ) : null;
  };

  /** setting column table */
  const prodcolumns = columnsParametersEditable(handleSave, unitOption, {
    handleAction,
    modalSelect: handleModalSelectLot,
  }).map((col) => {
    if (typeof col.onCell !== "function") return col;
    return {
      ...col,
      onCell: (record) => {
        const props = col.onCell(record);
        /* รายการที่รับของไปแล้ว หรือใบที่แก้ไม่ได้ → ไม่ให้แก้ช่อง */
        if (!canEditPo || isRowReceived(record)) return { ...props, editable: false };
        return props;
      },
    };
  });

  const SectionSupplier = (
    <>
      <Space size="small" direction="vertical" className="flex gap-2">
        <Row gutter={[8, 8]} className="m-0">
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item
              name="supcode"
              htmlFor="supcode-1"
              label="รหัสผู้ขาย"
              className="!mb-1"
              rules={[{ required: true, message: "Missing Supplier Code" }]}
            >
              <Space.Compact style={{ width: "100%" }}>
                <Input
                  readOnly
                  placeholder="เลือก ผู้ขาย"
                  id="supcode-1"
                  value={formDetail.supcode}
                  className="!bg-white"
                />
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  onClick={() => setOpenSupplier(true)}
                  disabled={isPartialReceived}
                  style={{ minWidth: 40 }}
                ></Button>
              </Space.Compact>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item name="supname" label="ชื่อผู้ขาย" className="!mb-1">
              <Input placeholder="ชื่อผู้ขาย" readOnly />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24}>
            <Form.Item name="address" label="ที่อยู่ผู้ขาย" className="!mb-1">
              <Input placeholder="ที่อยู่ผู้ขาย" readOnly />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[8, 8]} className="m-0">
          <Col xs={24} sm={24} md={6} lg={6}>
            <Form.Item label="วันที่นัดส่งของ" name="deldate" className="!m-0">
              <DatePicker
                size="large"
                placeholder="วันที่นัดส่งของ."
                className="input-40"
                style={{ width: "100%" }}
                format={dateFormat}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={6} lg={6}>
            <Form.Item
              label="การชำระเงิน"
              name="payment"
              rules={[{ required: true, message: "Please input your data!" }]}
            >
              <Select
                style={{ height: 40 }}
                options={[
                  { value: "เงินสด", label: "เงินสด" },
                  { value: "7 วัน", label: "7 วัน" },
                  { value: "15 วัน", label: "15 วัน" },
                  { value: "30 วัน", label: "30 วัน" },
                  { value: "45 วัน", label: "45 วัน" },
                  { value: "60 วัน", label: "60 วัน" },
                  { value: "90 วัน", label: "90 วัน" },
                  { value: "120 วัน", label: "120 วัน" },
                ]}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={6} lg={6}>
            <Form.Item name="poqua" label="ใบเสนอราคา" className="!mb-1">
              <Input placeholder="ใบเสนอราคา" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={4} lg={4}>
            <Form.Item label="Vat" name="vat">
              <Radio.Group>
                <Radio value={"7"}>มี Vat</Radio>
                <Radio value={"0"}>ไม่มี Vat</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[8, 8]} className="m-0">
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item name="ship_to" label="สถานที่จัดส่ง" className="!mb-1">
              <Select
                placeholder="เลือกสถานที่จัดส่ง"
                allowClear
                style={{ height: 40 }}
                options={[
                  { value: "ส่งที่ โรงงานระยอง", label: "ส่งที่ โรงงานระยอง" },
                  {
                    value: "ศศิพิมพ์ โชคประเสริฐขนส่งสาย 2 โทร 028859840",
                    label: "ศศิพิมพ์ โชคประเสริฐขนส่งสาย 2 โทร 028859840",
                  },
                ]}
              />
            </Form.Item>
          </Col>
        </Row>
      </Space>
    </>
  );

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            รายการสินค้า
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex justify="end">
          <Button
            icon={<LuPackageSearch style={{ fontSize: "1.2rem" }} />}
            className="bn-center justify-center bn-primary-outline"
            onClick={() => {
              form
                .validateFields()
                .then(() => {
                  setOpenProduct(true);
                })
                .catch((err) => {
                  message.error("กรุณาเลือกผู้ขายก่อน");
                });
            }}
            disabled={!canEditPo}
          >
            Choose Product
          </Button>
        </Flex>
      </Col>
    </Flex>
  );

  /* ตารางค่าบริการเพิ่ม — อยู่ใต้รายการสินค้า
     รหัส/ชื่อค่าบริการมาจากทะเบียนย่อยของหน้านี้ (er_po_service)
     กดปุ่ม + ข้างหัวตารางเพื่อเพิ่มรายการใหม่เข้าไปในทะเบียน */
  const serviceColumns = [
    {
      title: "#",
      dataIndex: "seq",
      width: 50,
      align: "center",
    },
    {
      title: "รหัสค่าบริการ",
      dataIndex: "service_code",
      width: 200,
      render: (v, rec) => (
        <Select
          value={v || undefined}
          placeholder="เลือกค่าบริการ"
          style={{ width: "100%" }}
          allowClear
          showSearch
          optionFilterProp="label"
          options={serviceOption.map((o) => ({
            value: o.code,
            label: `${o.code} - ${o.name}`,
          }))}
          onChange={(val) => handleServicePick(rec.seq, val)}
        />
      ),
    },
    {
      title: "ชื่อค่าบริการ",
      dataIndex: "service_name",
      render: (v, rec) => (
        <Input
          value={v || ""}
          placeholder="ชื่อค่าบริการ"
          onChange={(e) =>
            handleServiceChange(rec.seq, { service_name: e.target.value })
          }
        />
      ),
    },
    {
      title: "จำนวนเงิน",
      dataIndex: "amount",
      width: 160,
      align: "right",
      render: (v, rec) => (
        <InputNumber
          className="width-100 text-end"
          value={v}
          controls={false}
          min={0}
          placeholder="0.00"
          onFocus={(e) => e.target.select()}
          onChange={(val) => handleServiceChange(rec.seq, { amount: val || 0 })}
        />
      ),
    },
    {
      title: "หมายเหตุ",
      dataIndex: "remark",
      width: 220,
      render: (v, rec) => (
        <Input
          value={v || ""}
          placeholder="หมายเหตุ"
          onChange={(e) =>
            handleServiceChange(rec.seq, { remark: e.target.value })
          }
        />
      ),
    },
    {
      title: "",
      key: "action",
      width: 60,
      align: "center",
      render: (_, rec) => (
        <Popconfirm
          title="ลบรายการนี้?"
          okText="ลบ"
          cancelText="ยกเลิก"
          onConfirm={() => handleServiceDelete(rec.seq)}
        >
          <Button size="small" danger icon={<RiDeleteBin5Line />} />
        </Popconfirm>
      ),
    },
  ];

  const SectionService = (
    <Flex className="width-100" vertical gap={4}>
      <Table
        title={() => (
          <Flex className="width-100" align="center" justify="space-between">
            <Typography.Title className="m-0" level={5}>
              ค่าบริการเพิ่ม
            </Typography.Title>
            <Space>
              <Button
                size="small"
                icon={<PlusOutlined />}
                onClick={() => setOpenServiceMaster(true)}
              >
                จัดการรหัสค่าบริการ
              </Button>
              <Button
                size="small"
                type="primary"
                icon={<PlusOutlined />}
                onClick={handleAddServiceRow}
              >
                เพิ่มรายการ
              </Button>
            </Space>
          </Flex>
        )}
        bordered
        size="small"
        rowKey="seq"
        columns={serviceColumns}
        dataSource={listService}
        pagination={false}
        scroll={{ x: "max-content" }}
        locale={{ emptyText: <span>ยังไม่มีค่าบริการเพิ่ม</span> }}
        summary={() =>
          listService.length > 0 ? (
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={3} align="end" className="!pe-3">
                <Typography.Text strong>รวมค่าบริการ</Typography.Text>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={3} align="end" className="!pe-3">
                <Typography.Text strong>
                  {formatMoney(Number(serviceTotal || 0))}
                </Typography.Text>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={4} colSpan={2} />
            </Table.Summary.Row>
          ) : null
        }
      />
    </Flex>
  );

  const SectionProduct = (
    <>
      <Flex className="width-100" vertical gap={4}>
        <Table
          title={() => TitleTable}
          components={componentsEditable}
          rowClassName={() => "editable-row"}
          bordered
          dataSource={listDetail}
          columns={prodcolumns}
          pagination={false}
          rowKey="stcode"
          scroll={{ x: 980 }}
          locale={{
            emptyText: <span>No data available, please add some data.</span>,
          }}
        />

        <div className="mt-3">{SectionService}</div>

        {listDetail.length > 0 && (
          /* กล่องสรุปยอด — แยกออกมาจากตาราง จะได้ไม่ต้องยืด colSpan
             ให้ป้าย/ช่องกรอก/ตัวเลข อยู่ในแนวเดียวกันทุกแถว */
          <Flex justify="end" className="width-100 mt-2">
            <Flex vertical gap={8} style={{ width: 460, maxWidth: "100%" }}>
              <Flex justify="space-between" align="center" gap={12}>
                <Typography.Text style={{ width: 120, textAlign: "right" }}>
                  ยอดรวม
                </Typography.Text>
                <div style={{ width: 110 }} />
                <Typography.Text strong style={{ flex: 1, textAlign: "right" }}>
                  {formatMoney(Number(formDetail?.total_price || 0))} Baht
                </Typography.Text>
              </Flex>

              {/* ส่วนลดรวมท้ายบิล : กรอก % เพื่อคำนวณตัวเลข หรือกรอกตัวเลขตรงๆ ก็ได้ */}
              <Flex justify="space-between" align="center" gap={12}>
                <Typography.Text style={{ width: 120, textAlign: "right" }}>
                  ส่วนลดรวม
                </Typography.Text>
                <Form.Item name="discount_percent" className="!m-0" style={{ width: 110 }}>
                  <InputNumber
                    className="width-100 input-30 text-end"
                    addonAfter="%"
                    controls={false}
                    min={0}
                    max={100}
                    placeholder="0"
                    onFocus={(e) => e.target.select()}
                    onChange={(v) => handleSummaryPrice({ discount_percent: v })}
                  />
                </Form.Item>
                <Form.Item name="total_discount" className="!m-0" style={{ flex: 1 }}>
                  <InputNumber
                    className="width-100 input-30 text-end"
                    controls={false}
                    min={0}
                    placeholder="0.00"
                    onFocus={(e) => e.target.select()}
                    onChange={(v) => handleSummaryPrice({ total_discount: v })}
                  />
                </Form.Item>
              </Flex>

              <Flex justify="space-between" align="center" gap={12}>
                <Typography.Text style={{ width: 120, textAlign: "right" }}>
                  ภาษีมูลค่าเพิ่ม
                </Typography.Text>
                <Form.Item name="vat" className="!m-0" style={{ width: 110 }}>
                  <InputNumber
                    className="width-100 input-30 text-end"
                    addonAfter="%"
                    controls={false}
                    min={0}
                    onFocus={(e) => e.target.select()}
                    onChange={() => handleSummaryPrice()}
                  />
                </Form.Item>
                <Typography.Text style={{ flex: 1, textAlign: "right" }}>
                  {formatMoney(
                    Number((formDetail.total_price * formDetail?.vat) / 100)
                  )}{" "}
                  Baht
                </Typography.Text>
              </Flex>

              <Flex
                justify="space-between"
                align="center"
                gap={12}
                style={{ borderTop: "1px solid #f0f0f0", paddingTop: 8 }}
              >
                <Typography.Text strong style={{ width: 120, textAlign: "right", fontSize: "1rem" }}>
                  ยอดสุทธิ
                </Typography.Text>
                <div style={{ width: 110 }} />
                <Typography.Text
                  type="danger"
                  strong
                  style={{ flex: 1, textAlign: "right", fontSize: "1.05rem" }}
                >
                  {formatMoney(Number(formDetail?.grand_total_price || 0))} Baht
                </Typography.Text>
              </Flex>
            </Flex>
          </Flex>
        )}
      </Flex>
    </>
  );

  const SectionOther = (
    <>
      <Space size="small" direction="vertical" className="flex gap-2">
        <Row gutter={[8, 8]} className="m-0">
          <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
            <Form.Item className="" name="remark" label="Remark">
              <Input.TextArea placeholder="Enter Remark" rows={4} />
            </Form.Item>
          </Col>
        </Row>
      </Space>
    </>
  );

  ///** button */

  const SectionTop = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={gotoFrom} />
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          {formDetail.doc_status === "ยังไม่ได้รับของ" &&
            config?.action !== "create" && (
              <Popconfirm
                placement="topRight"
                title="ยืนยันการยกเลิก"
                description="คุณแน่ใจที่จะยกเลิกใบสั่งซื้อ?"
                icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                onConfirm={() => handleCancel()}
              >
                <Button
                  className="bn-center justify-center"
                  icon={<CloseCircleFilledIcon style={{ fontSize: "1rem" }} />}
                  type="primary"
                  style={{ width: "9.5rem" }}
                  danger
                >
                  ยกเลิกใบสั่งซื้อ
                </Button>
              </Popconfirm>
            )}
          <Button
            className="bn-center justify-center"
            icon={<SaveFilled style={{ fontSize: "1rem" }} />}
            type="primary"
            style={{ width: "9.5rem" }}
            onClick={() => {
              handleConfirm();
            }}
            disabled={!canEditPo}
          >
            Save
          </Button>
        </Flex>
      </Col>
    </Row>
  );

  const SectionBottom = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={gotoFrom} />
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Button
            className="bn-center justify-center"
            icon={<SaveFilled style={{ fontSize: "1rem" }} />}
            type="primary"
            style={{ width: "9.5rem" }}
            onClick={() => {
              handleConfirm();
            }}
            disabled={!canEditPo}
          >
            Save
          </Button>
        </Flex>
      </Col>
    </Row>
  );

  return (
    <div className="purchaseorder-manage">
      <div id="purchaseorder-manage" className="px-0 sm:px-0 md:px-8 lg:px-8">
        <Space direction="vertical" className="flex gap-4">
          {SectionTop}
          <Form
            form={form}
            layout="vertical"
            className="width-100"
            autoComplete="off"
          >
            <Card
              title={
                <>
                  <Row className="m-0 py-3 sm:py-0" gutter={[12, 12]}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                      {config?.action === "create" ? (
                        /* ตอนสร้างใหม่ : แก้รหัสเองได้ ถ้าไม่แก้จะใช้เลขรันอัตโนมัติ */
                        <Flex gap={10} align="center" wrap="wrap">
                          <Typography.Title level={3} className="m-0">
                            รหัสใบสั่งซื้อ :
                          </Typography.Title>
                          <Form.Item
                            name="pocode"
                            className="!m-0"
                            validateStatus={poCodeDup ? "error" : undefined}
                            help={
                              poCodeDup
                                ? "รหัสนี้ถูกใช้ไปแล้ว กรุณาเปลี่ยนรหัสใหม่"
                                : undefined
                            }
                          >
                            <Input
                              className="input-40"
                              style={{ width: 200 }}
                              placeholder="รหัสใบสั่งซื้อ"
                              onChange={(e) => handlePoCodeChange(e.target.value)}
                            />
                          </Form.Item>
                          {poCodeDup === false && poCode !== autoPoCode && (
                            <Typography.Text type="success" style={{ fontSize: 12 }}>
                              ใช้รหัสนี้ได้
                            </Typography.Text>
                          )}
                        </Flex>
                      ) : (
                        <Typography.Title level={3} className="m-0">
                          รหัสใบสั่งซื้อ : {poCode}
                        </Typography.Title>
                      )}
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                      <Flex
                        gap={10}
                        align="center"
                        className="justify-start sm:justify-end"
                      >
                        <Typography.Title level={3} className="m-0">
                          วันที่ใบสั่งซื้อ :{" "}
                        </Typography.Title>
                        <Form.Item name="podate" className="!m-0">
                          <DatePicker
                            className="input-40"
                            allowClear={false}
                            onChange={handleQuotDate}
                            format={dateFormat}
                          />
                        </Form.Item>
                      </Flex>
                    </Col>
                  </Row>
                </>
              }
            >
              <Row className="m-0" gutter={[12, 12]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <Divider orientation="left" className="!mb-3 !mt-1">
                    {" "}
                    ผู้ขาย{" "}
                  </Divider>
                  <Card style={cardStyle}>{SectionSupplier}</Card>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <Divider orientation="left" className="!mb-3 !mt-1">
                    {" "}
                    ข้อมูลเพิ่มเติม{" "}
                  </Divider>
                  <Card style={cardStyle}>{SectionOther}</Card>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <Divider orientation="left" className="!my-0">
                    รายการสินค้าใบสั่งซื้อ
                  </Divider>
                  <Card style={{ backgroundColor: "#f0f0f0" }}>
                    {SectionProduct}
                  </Card>
                </Col>
              </Row>
            </Card>
          </Form>
          {SectionBottom}
        </Space>
      </div>

      {/* หน้าจัดการรหัสค่าบริการ — ทะเบียนย่อยของหน้าใบสั่งซื้อ */}
      <Modal
        title="จัดการรหัสค่าบริการ"
        open={openServiceMaster}
        onCancel={closeServiceMaster}
        footer={null}
        destroyOnClose
        width={680}
      >
        <Space direction="vertical" style={{ display: "flex" }} size="middle">
          <Flex gap={8} align="end" wrap>
            <div style={{ width: 160 }}>
              <Typography.Text>รหัสค่าบริการ</Typography.Text>
              <Input
                placeholder="เช่น SV001"
                value={newService.code}
                onChange={(e) =>
                  setNewService((p) => ({ ...p, code: e.target.value }))
                }
              />
            </div>
            <div style={{ flex: 1, minWidth: 200 }}>
              <Typography.Text>ชื่อค่าบริการ</Typography.Text>
              <Input
                placeholder="เช่น ค่าขนส่ง"
                value={newService.name}
                onChange={(e) =>
                  setNewService((p) => ({ ...p, name: e.target.value }))
                }
                onPressEnter={handleSaveServiceMaster}
              />
            </div>
            <Button type="primary" onClick={handleSaveServiceMaster}>
              {editingService ? "บันทึกการแก้ไข" : "เพิ่ม"}
            </Button>
            {editingService && (
              <Button
                onClick={() => {
                  setEditingService(null);
                  setNewService({ code: "", name: "" });
                }}
              >
                ยกเลิก
              </Button>
            )}
          </Flex>

          <Table
            size="small"
            bordered
            rowKey="code"
            dataSource={serviceOption}
            pagination={{ pageSize: 8, showSizeChanger: false }}
            locale={{ emptyText: <span>ยังไม่มีรหัสค่าบริการ</span> }}
            columns={[
              { title: "รหัส", dataIndex: "code", width: 140 },
              { title: "ชื่อค่าบริการ", dataIndex: "name" },
              {
                title: "ใช้งานแล้ว",
                dataIndex: "used_count",
                width: 110,
                align: "center",
                render: (v) => `${Number(v || 0)} รายการ`,
              },
              {
                title: "",
                key: "action",
                width: 100,
                align: "center",
                render: (_, rec) => (
                  <Space size={4}>
                    <Button
                      size="small"
                      icon={<EditOutlined />}
                      onClick={() => handleEditServiceMaster(rec)}
                    />
                    <Popconfirm
                      title="ลบรหัสนี้?"
                      okText="ลบ"
                      cancelText="ยกเลิก"
                      disabled={Number(rec.used_count || 0) > 0}
                      onConfirm={() => handleDeleteServiceMaster(rec)}
                    >
                      <Button
                        size="small"
                        danger
                        icon={<RiDeleteBin5Line />}
                        disabled={Number(rec.used_count || 0) > 0}
                        title={
                          Number(rec.used_count || 0) > 0
                            ? "ถูกใช้ในใบสั่งซื้อแล้ว ลบไม่ได้"
                            : "ลบ"
                        }
                      />
                    </Popconfirm>
                  </Space>
                ),
              },
            ]}
          />
        </Space>
      </Modal>

      {openSupplier && (
        <ModalSupplier
          show={openSupplier}
          close={() => setOpenSupplier(false)}
          values={(v) => {
            handleChoosedSupplier(v);
          }}
        ></ModalSupplier>
      )}

      {openProduct && (
        <ModalBuyMaterial
          show={openProduct}
          close={() => setOpenProduct(false)}
          supcode={form.getFieldValue("supcode")}
          values={(v) => {
            handleItemsChoosed(v);
          }}
          selected={listDetail}
        ></ModalBuyMaterial>
      )}

      {openLot && (
        <ModalSelectLot
          open={openLot}
          close={() => setOpenLot(false)}
          record={lotRecord}
          confirm={handleConfirmLot}
        />
      )}
    </div>
  );
}

export default PurchaseOrderManage;
